module.exports = __webpack_public_path__ + "img/deletemodal.fdf23a61.svg";